import { Fragment } from "react";
import { getStore } from "@store";
//actions
import { setError, setAlertDock } from "@actions/global";
//helpers
import { isEmptyObject } from "@utils/object-helpers";
import Ajv from "ajv";
import Ajv2020 from "ajv/dist/2020";
import addFormats from "ajv-formats";
import cloneDeep from "lodash/cloneDeep";
import { getSchemaError } from "./schemaManagementInterface";
//constants
import { SYPI_ERROR_TYPES } from "@constants";
import { AJV_2020_VALIDATION } from "@constants/schema-management";
//adapters
import schemaManagementAdapter from "@features/schema-management/adapters";

export const dispatchWalletsErrors = (
  configToValidate,
  configSchema,
  release_version = "",
  store = false
) => {
  if (configToValidate.length || !store) {
    const validationOptions = { allErrors: true, multipleOfPrecision: 8 };
    const entireValidation =
      configSchema.$schema === AJV_2020_VALIDATION
        ? new Ajv2020(validationOptions)
        : new Ajv(validationOptions); //here for precaution; may be deleted once all schemas in use are 2020 versions
    addFormats(entireValidation);
    const copyConfigToValidate = cloneDeep(configToValidate);
    const validatedWhole = entireValidation.validate(
      configSchema,
      copyConfigToValidate
    );
    let fullErrorReport = {
      schemaErrors: [],
      configMissingKeys: [],
      hasMinLenght: [],
      otherErrors: [],
    };
    let configSchemaError = {};
    if (!validatedWhole) {
      const { errors } = entireValidation;
      for (let schemaError in errors) {
        let path = errors[schemaError].instancePath
          .substring(1)
          .replace(/\//g, ".");
        if (
          errors[schemaError].keyword ===
            SYPI_ERROR_TYPES.ADDITIONAL_PROPERTIES ||
          errors[schemaError].keyword === SYPI_ERROR_TYPES.TYPE
        ) {
          configSchemaError = {
            ...configSchemaError,
            ...getSchemaError(errors[schemaError]),
          };
          fullErrorReport.schemaErrors = Object.keys(configSchemaError).map(
            (schemaError) => configSchemaError[schemaError].customMessage
          );
        } else {
          let subNestedPath = Object.values(errors[schemaError].params)[0];
          let finalMessage = `${subNestedPath} ${errors[schemaError].message} ${path}.${subNestedPath}`;
          fullErrorReport.otherErrors.push(finalMessage);
        }
      }
    }

    if (store) {
      sendGlobalWaletsError(configSchemaError, release_version);
    }
    return {
      fullErrorReport,
      configSchemaError,
      errors: entireValidation.errors,
    };
  }
};

const sendGlobalWaletsError = (
  configSchemaError,
  release_version,
  store = getStore()
) => {
  const { activeReleaseVersion, initialReleaseVersion } =
    store.getState().schema;
  const releaseVersion = release_version
    ? release_version
    : initialReleaseVersion;

  if (
    configSchemaError &&
    !isEmptyObject(configSchemaError) &&
    releaseVersion === activeReleaseVersion
  ) {
    store.dispatch(setError(configSchemaError));
    store.dispatch(
      setAlertDock({
        title: "Schema Config Sync Error",
        message: (
          <Fragment>
            The following errors in the configuration file {releaseVersion} have
            a conflict with schema validation: <br />
            {Object.values(configSchemaError).map((error) => (
              <b key={error.fullPath}>
                {`${error.customMessage}.`} <br />
              </b>
            ))}
            Please contact the application development team for assistance.
          </Fragment>
        ),
      })
    );
  } else {
    store.dispatch(setError({}));
  }
};
